import { apiFetch } from './api';
import { RequestOptions, requestWith } from './http';

export function commerceRequest<T>(path: string, options: RequestOptions = {}): Promise<T> {
  return requestWith<T>(apiFetch, path, options);
}
